<template>
  <div class="employment">
    <div class="base-search">
      <el-button
        type="success"
        icon="el-icon-plus"
        @click="addEvent"
        style="background: #623aa2; border: none"
      >
        新增
      </el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
      <el-input
        placeholder="请输入内容"
        v-model="listQuery.keyword"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 240px"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column
          type="index"
          :index="
            index => {
              return index + (listQuery.page - 1) * listQuery.pageSize + 1;
            }
          "
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column label="机构名称" align="center" prop="name"></el-table-column>
        <el-table-column
          label="机构类别"
          align="center"
          prop="institutionsCategoryName"
        ></el-table-column>
        <el-table-column
          label="技术领域"
          align="center"
          prop="technicalFieldName"
        ></el-table-column>
        <el-table-column
          label="科研条件"
          align="center"
          prop="researchConditionsName"
        ></el-table-column>
        <el-table-column
          label="获得资质"
          align="center"
          prop="qualificationsObtainedName"
        ></el-table-column>
        <el-table-column label="备注" align="center" prop="remark"></el-table-column>

        <el-table-column width="240px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="mini_btn"
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              class="mini_btn"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next,jumper"
      :total="total"
      :current-page.sync="listQuery.page"
      style="text-align:left;margin:20px 0"
      :page-size="listQuery.pageSize"
    ></el-pagination>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      v-if="dialogFormVisible"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="机构名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入机构名称"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构类别" prop="institutionsCategoryId">
              <el-select
                style="width: 100%"
                v-model="ruleForm.institutionsCategoryId"
                placeholder="请选择"
                @change="changeData($event, 'institutionsCategoryId')"
              >
                <el-option
                  v-for="item in jigouList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="技术领域" prop="technicalFieldId">
              <el-select
                style="width: 100%"
                @change="changeData($event, 'technicalFieldId')"
                v-model="ruleForm.technicalFieldId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in jishuList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="所属地区" prop="postalAddressDistinguish">
              <el-select
                style="width: 100%"
                v-model="ruleForm.postalAddressDistinguish"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>

          <el-row>
            <el-form-item label="科研条件" prop="researchConditionsId">
              <el-select
                style="width: 100%"
                @change="changeData($event, 'researchConditionsId')"
                v-model="ruleForm.researchConditionsId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in keyanList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="获得资质" prop="qualificationsObtainedId">
              <el-select
                style="width: 100%"
                @change="changeData($event, 'qualificationsObtainedId')"
                v-model="ruleForm.qualificationsObtainedId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in zishiList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="备注" prop="remark">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                v-model="ruleForm.remark"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="dialogType === 'add'">
          确 定
        </el-button>
        <el-button
          type="primary"
          @click="updateSubmitForm('ruleForm')"
          v-show="dialogType === 'edit'"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { areaList } from './components/options'
export default {
  data() {
    return {
      dialogType: '',
      listQuery: {
        keyword: '',
        is_page: 0,
        page: 1,
        pageSize: 10
      },
      deleteRow: [],
      jigouList: [],
      jishuList: [],
      keyanList: [],
      zishiList: [],
      areaList: areaList,
      total: 10,
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        name: '',
        postalAddressDistinguish: '',
        institutionsCategoryId: '',
        institutionsCategoryName: '',
        technicalFieldId: '',
        technicalFieldName: '',
        researchConditionsId: '',
        researchConditionsName: '',
        qualificationsObtainedId: '',
        qualificationsObtainedName: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: "请输入众创空间名称", trigger: "blur" }
        ],
        institutionsCategoryId: [
          { required: true, message: "请选择机构类别", trigger: "change" }
        ],
        postalAddressDistinguish: [
          { required: true, message: "请选择所属地区", trigger: "change" }
        ],
        technicalFieldId: [
          { required: true, message: "请选择技术领域", trigger: "change" }
        ],
        researchConditionsId: [
          { required: true, message: "请输入科研条件", trigger: "change" }
        ],
        qualificationsObtainedId: [
          { required: true, message: "请输入获得资质", trigger: "change" }
        ]
      },
    };
  },
  created() {
    this.getChuangxinList(
            'resource_research_institutions',
            'resource_engaged_field',
            'resource_research_conditions',
            'resource_qualified'
          );
    this.getData();
  },
  methods: {
     // 人才类别和从事技术领域
     getSiftList(type1, type2, type3, type4) {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
        dictTypes: [type1, type2, type3, type4]
      }).then(res => {
        if (res.code === 0) {
          const {resource_research_institutions, resource_engaged_field, resource_research_conditions, resource_qualified} = res.data;
            this.jigouList = [
              ...resource_research_institutions
            ]
            this.jishuList = [
              ...resource_engaged_field
            ]
            this.keyanList = [
              ...resource_research_conditions
            ]
            this.zishiList = [
              ...resource_qualified
            ]
        }
      })
    },
    // 人才类别和从事技术领域
    getChuangxinList(type1, type2, type3, type4) {
      this.$axios
        .all([
          this.http
            .get(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/page?is_page=1&dictType=${type1}`)
            .then(res => res.data.data),
          this.http
            .get(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/page?is_page=1&dictType=${type2}`)
            .then(res => res.data.data),
          this.http
            .get(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/page?is_page=1&dictType=${type3}`)
            .then(res => res.data.data),
          this.http
            .get(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/page?is_page=1&dictType=${type4}`)
            .then(res => res.data.data)
        ])
        .then(
          this.$axios.spread((val1, val2, val3, val4) => {
            this.jigouList = [
              ...val1
            ]
            this.jishuList = [
              ...val2
            ]
            this.keyanList = [
              ...val3
            ]
            this.zishiList = [
              ...val4
            ]
          })
        )
        .catch(err => {
          console.log(err);
        });
    },
    getData() {
    	this.http.post(this.urlConfig.devUrl+'apij2/admin-api/voucher/resource-research-institutions/page',this.listQuery).then(res =>{
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
				}
			})
    },
    //新增
    addEvent() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.dialogType = 'add'

      this.ruleForm = {
        name: '',
        postalAddressDistinguish: '',
        institutionsCategoryId: '',
        institutionsCategoryName: '',
        technicalFieldId: '',
        technicalFieldName: '',
        researchConditionsId: '',
        researchConditionsName: '',
        qualificationsObtainedId: '',
        qualificationsObtainedName: '',
        remark: ''
      };
    },
    	//选择页码
			handleCurrentChange(e) {
				this.listQuery.page = e;
				this.getData();
			},
  		//批量删除
    deleteAll() {
			if (this.deleteRow.length) {
				this.$confirm("此操作将批量删除, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http
            .request(this.urlConfig.devUrl + "/apij2/admin-api/voucher/resource-research-institutions/delete", {
              ids: this.deleteRow
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });

              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });

			} else {
        this.$message({
					type: "warning",
					message: "请选择删除的记录",
				});
      }
		},
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.dialogType = 'edit'
    },
    //删除
    handleDelete(index, row) {
      const data = [
        row.id
      ]
      this.$confirm("此操作将批量删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(this.urlConfig.devUrl + "apij2/admin-api/voucher/resource-research-institutions/delete", {
              ids: data
            }, "delete")
            .then((res) => {
              if (res.code == 0) {
                this.listQuery.page = 1;
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });

              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    changeData(id, type) {
      if (type === 'institutionsCategoryId') {
        const data = this.jigouList.find(item => item.id === id)
        this.ruleForm.institutionsCategoryName = data.label;
      } else if (type === 'technicalFieldId') {
        const data = this.jishuList.find(item => item.id === id)
        this.ruleForm.technicalFieldName = data.label;
      } else if (type === 'researchConditionsId') {
        const data = this.keyanList.find(item => item.id === id)
        this.ruleForm.researchConditionsName = data.label;
      } else if (type === 'qualificationsObtainedId') {
        const data = this.zishiList.find(item => item.id === id)
        this.ruleForm.qualificationsObtainedName = data.label;
      }
    },
    addData() {
      this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-research-institutions/create`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('新增成功');
        } else {
          this.$messgae.error('新增失败')
        }
      }).catch(e => {
        this.$messgae.error('新增失败')
      })
    },
    editData() {
      this.http.put(`${this.urlConfig.devUrl}apij2/admin-api/voucher/resource-research-institutions/update`, this.ruleForm).then(res => {
        if (res.code === 0) {
          this.getData()
          this.dialogFormVisible = false;
          this.$message.success('编辑成功');
        } else {
          this.$messgae.error('编辑失败')
        }
      }).catch(e => {
        this.$messgae.error('编辑失败')
      })
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 新增提交
          this.addData()
        } else {
          return false;
        }
      });
    },
    updateSubmitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 编辑提交
          this.editData()
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.employment {
  height: 100%;
  width: 100%;
  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 198px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}
</style>
